module.exports = __webpack_public_path__ + "02ab17bb46b4dc234f3e077c36a6f3e3.png";